module.exports = __webpack_public_path__ + "img/08.bc4ada03.png";